import { useTranslation } from 'react-i18next'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export interface SummaryItemSelectorOption {
  id: string
  label: string
}

interface SummaryItemSelectorProps {
  options: Array<SummaryItemSelectorOption>
  selected: string
  onChange: (id: string) => void
  label?: string
  /** Test id of the trigger; its options take `<testId>-option-<id>`. Two selectors on one card need two. */
  testId?: string
}

/**
 * Shared item/series selector for per-item summary plots (D14).
 *
 * The parent decides whether to mount this: render only when the payload
 * carries two or more items or series with data. One option, no selector.
 */
export function SummaryItemSelector(props: SummaryItemSelectorProps) {
  const { options, selected, onChange, label, testId = 'summary-item-select' } = props
  const { t } = useTranslation('app')
  const resolvedLabel = label ?? t('studyReport.itemSelect')

  return (
    <Select value={selected} onValueChange={onChange}>
      <SelectTrigger
        className="h-9 w-[180px]"
        data-testid={testId}
        aria-label={resolvedLabel}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem
            key={option.id}
            value={option.id}
            data-testid={`${testId}-option-${option.id}`}
          >
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
